import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Hero } from "../components/home/Hero";
import { ClientMarquee } from "../components/home/ClientMarquee";
import { CategoryBento } from "../components/home/CategoryBento";
import { Infrastructure } from "../components/home/Infrastructure";
import { Quality } from "../components/home/Quality";
import { Downloads } from "../components/home/Downloads";
import { CtaBand } from "../components/home/CtaBand";
import { IndustriesStrip } from "../components/home/IndustriesStrip";
import { countWord } from "../lib/industries";
import { Reveal, SectionHead } from "../components/site/Motion";
import { useCategories } from "../lib/api";
import { Seo } from "../components/site/Seo";

const AboutStrip = () => (
  <section data-testid="about-teaser" className="bg-white py-24 md:py-32">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <p className="eyebrow text-[#0a6cff] lg:col-span-3">01 — Who we are</p>
      <div className="lg:col-span-9">
        <Reveal>
          <p className="font-display text-4xl font-bold uppercase leading-[0.98] text-slate-950 sm:text-5xl lg:text-[4.2rem]">
            Since 2012, Autocrat has been the quiet partner behind <span className="text-[#0a6cff]">India's battery, power and automotive brands</span> — molding the rubber parts that keep their products sealed, insulated and running.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center gap-8">
          <Link to="/about" data-testid="about-teaser-link" className="group inline-flex items-center gap-3 text-sm font-semibold uppercase tracking-widest text-slate-950">
            Our story <span className="flex h-10 w-10 items-center justify-center bg-slate-950 text-white transition-transform duration-300 group-hover:translate-x-1"><ArrowRight className="h-4 w-4" /></span>
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default function Home() {
  const { categories } = useCategories();
  return (
    <div data-testid="home-page">
      <Seo path="/" title="Rubber Parts Manufacturer in Gurugram | Autocrat Rubber" description="Autocrat Rubber Industries makes molded rubber parts, grommets, bushes, gaskets, seals and O-rings for OEMs across India since 2012. Request a quote today." />
      <Hero />
      <ClientMarquee />
      <AboutStrip />
      <section data-testid="home-products-section" className="bg-slate-50 py-24 md:py-32">
        <div className="container-x">
          <div className="mb-14 flex flex-col justify-between gap-8 md:flex-row md:items-end">
            <SectionHead eyebrow="02 — The product index" title={<>{countWord(categories.length || 9)} families.<br />One standard.</>} />
            <Link to="/products" data-testid="view-all-products-link" className="btn-electric self-start md:self-end">View full catalogue <ArrowRight className="h-4 w-4" /></Link>
          </div>
          <CategoryBento categories={categories} />
        </div>
      </section>
      <IndustriesStrip />
      <Infrastructure />
      <Quality />
      <Downloads />
      <CtaBand />
    </div>
  );
}
